import React from "react";

export default function Sidebar({ active, onChange, sidebarOpen, showWebsite, showBusinessWebsite }) {

    return (
        <div className={`sidebar d-flex flex-column p-3 ${sidebarOpen ? "show" : ""}`}>

            {/* MAIN NAV */}
            <button
                className={`nav-btn ${active === "Dashboard" ? "active" : ""}`}
                onClick={() => onChange("Dashboard")}
            >
                <i className="bi bi-grid-fill me-2 text-purple"></i> Dashboard
            </button>

            {/* Admin Panel sections — rendered inline in this same dashboard now
                (see Admin.js), not a separate page. Still gated by
                AdminSectionGate (auto-unlocks for anyone already logged in
                to the main site — see the note there on why that's not a
                real permission system yet). */}
            <button
                className={`nav-btn ${active === "AdminHomepageImages" ? "active" : ""}`}
                onClick={() => onChange("AdminHomepageImages")}
            >
                <i className="bi bi-images me-2 text-sky"></i> Homepage Images
            </button>
            <button
                className={`nav-btn ${active === "AdminAdLeads" ? "active" : ""}`}
                onClick={() => onChange("AdminAdLeads")}
            >
                <i className="bi bi-telephone-inbound-fill me-2 text-sky"></i> Ad-Leads
            </button>
            <button
                className={`nav-btn ${active === "AdminAdSegments" ? "active" : ""}`}
                onClick={() => onChange("AdminAdSegments")}
            >
                <i className="bi bi-tags-fill me-2 text-sky"></i> Ad Segment
            </button>
            <button
                className={`nav-btn ${active === "AdminBecomeAgent" ? "active" : ""}`}
                onClick={() => onChange("AdminBecomeAgent")}
            >
                <i className="bi bi-person-badge-fill me-2 text-sky"></i> Become Agent
            </button>
            <button
                className={`nav-btn ${active === "AdminServiceInquiries" ? "active" : ""}`}
                onClick={() => onChange("AdminServiceInquiries")}
            >
                <i className="bi bi-headset me-2 text-sky"></i> Service Inquiries
            </button>
            <button
                className={`nav-btn ${active === "AdminPageManagement" ? "active" : ""}`}
                onClick={() => onChange("AdminPageManagement")}
            >
                <i className="bi bi-file-earmark-text-fill me-2 text-sky"></i> Page Management
            </button>
            <button
                className={`nav-btn ${active === "AdminSubdomains" ? "active" : ""}`}
                onClick={() => onChange("AdminSubdomains")}
            >
                <i className="bi bi-diagram-3-fill me-2 text-sky"></i> Sub-domains
            </button>
            <button
                className={`nav-btn ${active === "AdminContactMessages" ? "active" : ""}`}
                onClick={() => onChange("AdminContactMessages")}
            >
                <i className="bi bi-envelope-fill me-2 text-sky"></i> Contact Messages
            </button>
            <button
                className={`nav-btn ${active === "AdminWalletOverview" ? "active" : ""}`}
                onClick={() => onChange("AdminWalletOverview")}
            >
                <i className="bi bi-wallet2 me-2 text-sky"></i> Wallet Overview
            </button>
            <button
                className={`nav-btn ${active === "AdminRenewalHistory" ? "active" : ""}`}
                onClick={() => onChange("AdminRenewalHistory")}
            >
                <i className="bi bi-arrow-repeat me-2 text-sky"></i> Renewal History
            </button>
            <button
                className={`nav-btn ${active === "AdminTransferOwnership" ? "active" : ""}`}
                onClick={() => onChange("AdminTransferOwnership")}
            >
                <i className="bi bi-arrow-left-right me-2 text-sky"></i> Transfer Ownership
            </button>

            <button
                className={`nav-btn ${active === "MyListings" ? "active" : ""}`}
                onClick={() => onChange("MyListings")}
            >
                <i className="bi bi-card-list me-2 text-green"></i> Listing
            </button>

            <button
                className={`nav-btn ${active === "BulkUpload" ? "active" : ""}`}
                onClick={() => onChange("BulkUpload")}
            >
                <i className="bi bi-file-earmark-spreadsheet-fill me-2 text-green"></i> Bulk Upload
            </button>

            <button
                className={`nav-btn ${active === "Wallet" ? "active" : ""}`}
                onClick={() => onChange("Wallet")}
            >
                <i className="bi bi-wallet2 me-2 text-warning"></i> Wallet
            </button>

            {/* MY WEBSITES (only if the customer owns a website plan) */}
            {(showWebsite || showBusinessWebsite) && (
                <button
                    className={`nav-btn ${active === "MyWebsites" ? "active" : ""}`}
                    onClick={() => onChange("MyWebsites")}
                >
                    <i className="bi bi-collection-fill me-2 text-purple"></i> My Websites
                </button>
            )}

            <style>{`
                /* Sidebar Container */
                .sidebar {
                    width: 100%;
                    background: linear-gradient(180deg, #ffffff, #f7faff);
                    border-right: 1px solid #ececec;
                    height: 100%;
                }

                .nav-btn {
                    width: 100%;
                    border: none;
                    background: transparent;
                    padding: 12px;
                    font-size: 15px;
                    text-align: left;
                    border-radius: 8px;
                    margin-bottom: 8px;
                    color: #444;
                    cursor: pointer;
                    display: block;
                    text-decoration: none;
                    transition: 0.2s;
                }
                .nav-btn:hover {
                    background: #eef4ff;
                    transform: translateX(3px);
                }
                .nav-btn.active {
                    background: #e3ecff;
                    font-weight: 600;
                    border-left: 4px solid #2563eb;
                }

                .text-purple { color: #6f42c1; }
                .text-green { color: #0d8c31; }
                .text-orange { color: #ff7f32; }
                .text-gold { color: #c49b07; }
                .text-sky { color: #0ea5e9; }
                .text-red { color: #e11d48; }

                .sub-link {
                    font-size: 14px;
                    padding-left: 12px !important;
                    margin-bottom: 6px;
                    color: #666 !important;
                }
                .sub-link:hover {
                    background: #f1f6ff;
                    border-radius: 6px;
                }

                /* Desktop Sticky */
                @media (min-width: 768px) {
                    .sidebar {
                        width: 260px;
                        position: sticky;
                        top: 56px;
                        height: calc(100vh - 56px);
                        overflow-y: auto;
                        box-shadow: 2px 0 8px rgba(0,0,0,0.05);
                    }
                }

                /* Mobile Slide */
                @media (max-width: 768px) {
                    .sidebar {
                        position: fixed;
                        top: 0;
                        left: -260px;
                        width: 240px;
                        height: 100%;
                        z-index: 1050;
                        transition: all 0.3s ease;
                        box-shadow: 0 0 12px rgba(0,0,0,0.15);
                        overflow-y: auto;
                    }
                    .sidebar.show {
                        left: 0;
                    }
                }
            `}</style>
        </div>
    );
}
